import React from "react";
import * as Yup from "yup";
import CadastroPadrao from "../../../Components/Common/CadastroPadrao";

import {
  getFormasPagamento,
  addNewFormaPagamento,
  updateFormaPagamento,
  deleteFormaPagamento
} from "../../../slices/api/formaPagamento";

const FormaPagamento = () => {
  return (
  <CadastroPadrao
    titulo="Formas de Pagamento"
    labelSingular="FormaPagamento"
    reduxKey="formasPagamento"
    acoesRedux={{
      onGet: getFormasPagamento,
      onAddNew: addNewFormaPagamento,
      onUpdate: updateFormaPagamento,
      onDelete: deleteFormaPagamento,
    }}
    colunas={[
      { campo: "id", titulo: "Código" },
      { campo: "nome", titulo: "Nome" },
    ]}
    camposFormulario={[
      {
        nome: "nome",
        label: "Nome",
        placeholder: "Informe o nome da forma",
        validacao: Yup.string().required("Informe o nome da forma"),
      }
    ]}
  />
  );
};

export default FormaPagamento;